import React from 'react'
import { anaSponsorlar } from "./AnaSponsorlar";
import { Button, Card, CardBody, CardSubtitle, CardText, CardTitle } from 'reactstrap';

export default function AnaSponsorCard()
{
    return (
        <div class="container mt-3">
            <div class="row my-3 paydasCard sponsorCard sponsor">
                {
                    anaSponsorlar.map((sponsor, index) => (
                        <div class="col-md-4 my-3 text-center" key={index}>
                            <Card>
                                <div class="paydasImg">
                                    <img
                                        width="150px"
                                        alt={sponsor?.name}
                                        src={sponsor?.imageUrl}
                                    />
                                </div>
                                <CardBody>
                                    <a target='_blank' href={sponsor?.url}>
                                        {sponsor?.name}
                                    </a>
                                </CardBody>
                            </Card>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}
